import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { signIn } from 'next-auth/client';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Layout from '@/components/layout';

export default function Register() {
    const { t } = useTranslation('menu');
    const router = useRouter();
    const appSlug = router.query.app;

    return (
        <Layout title="Register" classes="mb-n6">
            <div className="container-fluid">
                <div className="row justify-content-start">
                    <div className="d-none d-lg-block col-lg-5 p-0">
                        <div className="bg-cover h-100 min-vh-100 mt-n1 me-n3" style={{ backgroundImage: "url('/img/wizard-bg.png')" }}></div>
                    </div>
                    <div className="col-12 col-lg-7 p-0">
                        <div className="container">
                            <div className="row justify-content-center my-6">
                                <div className="col-12 col-md-8">
                                    <h1 className="display-4 text-center mb-3">Bitte melden Sie sich an...</h1>
                                    <p className="text-muted text-center mb-5">
                                        Ein Konto für alle Produkte.
                                    </p>
                                    <p className="text-center">
                                        <a
                                            href={`/api/auth/signin`}
                                            className="btn btn-outline-primary btn-lg text-nowrap"
                                            data-cy="login-button"
                                            onClick={(e) => {
                                                e.preventDefault();

                                                if (appSlug) {
                                                    signIn('keycloak', { callbackUrl: `/apps/${appSlug}/buy` });
                                                } else {
                                                    signIn('keycloak');
                                                }
                                            }}
                                        >
                                            <i className="fe fe-user mr-2"></i>{t('login')}</a>
                                        <Link href={`/register/wizard${(appSlug) ? `?app=${appSlug}` : ''}`}>
                                            <a className="btn btn-lg btn-primary ml-3" data-cy="signup-button">Registrieren <i className="fe fe-arrow-right"></i></a>
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...await serverSideTranslations(locale, ['common', 'menu'])
        }
    }
}
